import { motion } from 'framer-motion';
import { createStyles, Button } from '@mantine/core';
import { useEffect, useState } from 'react';
import JumboTron1 from '../components/jumbotron-1/jumbotron1-component';
import JumboTron2 from '../components/jumbotron-2/jumbotron2-component';
import ToolTip2 from '../components/tooltip/toolTip2-component';
import CardTypeHouseCompo from '../components/typeHouse/cardtypehouse-component';
import style from '../styles/housingTypePageStyle.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FooterCompo } from '../components';
import {
  fetchProperties,
  propertySearchIsEmpty,
  propertySearchStore,
} from '../store/reducers/propertySearchSlice';
import Swal from 'sweetalert2';

const useStyle = createStyles((theme) => ({
  row: {
    '@media (max-width: 600px)': {
      margin: 10,
    },
  },
}));

const ResultPage = () => {
  const { classes } = useStyle();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedCity, setSelectedCity] = useState(searchParams.get('city'));
  const propertySearch = useSelector(propertySearchStore);
  const propertyCheck = useSelector(propertySearchIsEmpty);
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const transaction = searchParams.get('transaction'),
    categories = searchParams.get('categories');

  async function searchProperties(uid, updated_at) {
    try {
      if (transaction?.length > 0 && categories?.length > 0) {
        dispatch(
          await fetchProperties(
            selectedCity ?? 'jember',
            transaction,
            categories,
            uid,
            updated_at
          )
        );
      } else {
        Swal.fire({
          title: 'Error!',
          text: 'Silahkan Pilih Properti dan Jenis Properti',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      }
    } catch (error) {
      console.log(error).catch((err) => {
        return Swal.fire({
          title: 'Error!',
          text: 'Silahkan Pilih Properti dan Jenis Properti dengan valid!',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      });
    }
  }

  useEffect(() => {
    // setSelectedCity();
    // if (propertyCheck) {
    //   navigate('/pencarian')
    // }
  }, []);

  return (
    <motion.div
      className="main"
      style={{ overflowX: 'hidden' }}
      initial={{ width: 0 }}
      animate={{ width: '100%' }}
      exit={{ x: window.innerWidth, transition: { duration: 0.3 } }}
    >
      {selectedCity && <JumboTron1 city={selectedCity} />}
      <div className="container">
        {/* ToolTip Compo*/}
        <div
          className={`${style.toolTipWrapper} d-flex flex-row mt-5 align-items-center`}
        >
          <p>Hasil Pencarian</p>
          <ToolTip2 />
        </div>
        {/* End ToolTp Compo*/}
        {/* Type House Compo */}

        <div className="row justify-content-center mt-5">
          {propertySearch?.map((item, key) => {
            return (
              <div className="col-sm-12 col-md-10 col-lg-4" key={key}>
                <CardTypeHouseCompo
                  id={item.id}
                  image={item.images[0]}
                  title={item.name}
                  address={`${item.address.street}, ${
                    item.address.lower_city[0].toUpperCase() +
                    item.address.lower_city.substring(1)
                  }`}
                />
              </div>
            );
          })}
          {propertySearch.length % 3 === 0 && (
            <Button
              mt={30}
              mb={30}
              color="teal.9"
              radius="xl"
              className={classes.button}
              onClick={async () =>
                await searchProperties(
                  propertySearch[propertySearch.length - 1].id,
                  propertySearch[propertySearch.length - 1].updated_at.seconds
                )
              }
            >
              Lainnya
            </Button>
          )}
        </div>

        {/* End Type House */}
      </div>
      <JumboTron2 />
      <FooterCompo />
    </motion.div>
  );
};

export default ResultPage;
